import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.createdBy;

const getCreatedBy = createSelector(getData, createdBy => values(createdBy));

export default getCreatedBy;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getCreatedBy.js